<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" @click="toggleSelectAll" class="btn btn-fill btn-primary mr-3">
          Alle auswählen
        </button>

        <button class="btn btn-success" @click="restoreSelectedUsers">
          <i class="fa fa-recycle"></i>
          Ausgewählte Benutzer wiederherstellen/aktivieren
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <p v-if="users.length === 0">Keine gelöschten Benutzer vorhanden.</p>
          <transition name="el-fade-in-linear">
            <table class="table table-striped table-bordered" v-if="users.length">
              <thead>
                <tr>
                  <th width="10px">&nbsp;</th>
                  <th>Name</th>
                  <th>Role</th>
                  <th>Letzer login am</th>
                </tr>
              </thead>
              <tr v-for="user in users" :key="user.id">
                <td class="handle"> <input type="checkbox" :value="user.id" v-model="selectedUsers"></td>
                <td v-text="user.name"></td>
                <td v-text="user.role"></td>
                <td v-text="user.last_login_at"></td>
              </tr>
            </table>
          </transition>
        </div>
      </div>
       <a href="/users">
         <button type="submit" class="btn btn-fill btn-info mr-3">
          Zurück
        </button>
      </a>
    </card>
  </div>
</template>

<script>

export default {
  data() {
    return {
      users: [],
      selectedUsers: [],
      selectAll: false,
    }
  },
  methods: {
    getData(query) {
      this.$http.get(`/soft_deleted/users`).then(({ data }) => {
        this.users = data
      })
    },
    toggleSelectAll() {
      this.selectAll = !this.selectAll
      if (this.selectAll) {
        this.selectedUsers = this.users.map(user => user.id);
      } else {
        this.selectedUsers = [];
      }
    },
    restoreSelectedUsers() {
      if (this.selectedUsers.length) {
        const selectedUsers = this.users.filter(user => this.selectedUsers.includes(user.id));
        const selectedUsersIds = selectedUsers.map(user => user.id)
        const selectedUsersNames = selectedUsers.map(user => user.name)
        this.$http.post(`/soft_deleted/users/restore`, { ids: selectedUsersIds }).then(() => {
          this.$notify({
            message: `Benutzer: ${selectedUsersNames} erfolgreich wiederhergestellt.`,
            type: 'success'
          });
          this.getData();
          setTimeout(() => {
            this.$router.push('/users');
          }, 2000);
        })
      }
    },
  },
  created() {
    this.getData()
  }
}
</script>
